
import React, { useEffect, useState } from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { utils } from '../../../core';

import getStylesFromCssString from './getStylesFromCssString';
import getStylesFromDefinition from './getStylesFromDefinition';
import processTemplateValues from './processTemplateValues';

const AttributeDownloadContent = ({appConfig, definition, infoDefinition, values}) => {
    const classNames = mergeStyleSets({
        root: {
            paddingTop: 2,
            paddingBottom: 2,
            ...getStylesFromDefinition(appConfig, 'info.styles.attrContainer'),
            ...getStylesFromDefinition(infoDefinition, 'styles.attrContainer'),
            ...getStylesFromCssString(definition.containerStyles)
        },
        title: {
            ...getStylesFromDefinition(appConfig, 'info.styles.attrTitle'),
            ...getStylesFromDefinition(infoDefinition, 'styles.attrTitle'),
            ...getStylesFromCssString(infoDefinition.containerStyles),
        },
        value: {
            fontWeight: 'bold',
            ...getStylesFromDefinition(appConfig, 'info.styles.attrValue'),
            ...getStylesFromDefinition(infoDefinition, 'styles.attrValue'),
        }
    });

    const [content, setContent] = useState('Načítám data...');

    useEffect(() => {
        let url = processTemplateValues(definition.url, values);
        utils.loadTextFromUrl(url, (err, result) => {
            if (!err) {
                setContent(result);
            }
        });
    }, []);

    return (
        <Stack className={classNames.root}>
            <Stack.Item className={classNames.title}>
                {definition.title
                    ? <div>{definition.title} :</div>
                    : null
                }
            </Stack.Item>
            <Stack.Item className={classNames.content}>
                <div dangerouslySetInnerHTML={{__html: content}}></div>
            </Stack.Item>
        </Stack>
    );
}

export default AttributeDownloadContent;
